module.exports = __webpack_public_path__ + "static/dc-automation-84682f9f4ed713d106dab8619ea3bc68.gif";